import type { HoldingsProbeClient } from "./probeHasHoldings";

/**
 * 持仓探测用的 member client 注册表（模式同 `setChecklistApiClients`）。
 *
 * 为什么不直接 `useOspApiClientProvider()`：`auth_signin_success` 有三个发射点
 * （登录页 / 登录弹窗 / 邮箱登录弹窗），挂载位置不一，hook 在 Provider 外会抛错；
 * `OspApiClientProvider` 全站唯一挂载一次，在那里注册即可，未注册时按「无持仓」处理。
 */
let holdingsProbeClient: HoldingsProbeClient | null = null;

export function setHoldingsProbeClient(
  client: HoldingsProbeClient | null | undefined,
): void {
  holdingsProbeClient = client ?? null;
}

export function getHoldingsProbeClient(): HoldingsProbeClient | null {
  return holdingsProbeClient;
}
